<template>
  <div class="button" @click="execute">
    <span class="button-label">{{ label }}</span>
    <svg class="button-play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="12" cy="12" r="10.2" fill="none" stroke="#ffffff" stroke-width="2.5"></circle>
      <path d="M9 7.3 L16.7 12 L9 16.7 Z" fill="#ffffff"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'surgic-star-button',
  props: {
    url: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Watch Video'
    }
  },
  methods: {
    execute() {
      this.$emit('onclick', this.url);
    }
  }
}
</script>

<style scoped>
.button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 171px;
  height: 46.5px;
  border-radius: 23.25px;
  background-color: rgba(142,142,142, .6);
  transition: background .3s linear 0s;
}

.button:hover {
  background-color: rgba(142,142,142, .7);
}

.button-label {
  font-family: 'MiSans-Normal', sans-serif;
  font-size: 17px;
  line-height: 1;
  font-weight: normal;
  color: #ffffff;
  white-space: nowrap;
}

.button-play {
  width: 23.7px;
  height: 23.7px;
  margin-left: 9.3px;
  display: block;
  flex: none;
}
</style>
